import { BaseRecordSchema, defineValidation } from "../../common/validation.common";

export namespace RadiusSessionValidation {
    export const Record = defineValidation(BaseRecordSchema);
}
